var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.banners),function(banner){return _c('div',{key:banner.url,staticClass:"c-banner"},[_c('a',{attrs:{"href":banner.url,"target":banner.target}},[_c('img',{staticClass:"c-banner__image",attrs:{"src":banner.image}})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }